module.exports = __webpack_public_path__ + "static/img/logo.f33f2338.png";